import React, { lazy } from 'react';
import { redirect } from 'react-router-dom';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import ProtectedRoute from 'src/pages/utility/ProtectedRoute';
import { roleSet } from 'src/constants/role';
import type { AppRoute } from '../types';
import { periodSalesTabs } from 'src/pages/reports/PeriodSalesPage';

const PromoCodesPage = lazy(() => import('src/pages/reports/PromoCodesPage'));
const SalesPage = lazy(() => import('src/pages/reports/SalesPage'));
const ReceivingMethodsPage = lazy(
  () => import('src/pages/reports/ReceivingMethods')
);
const TicketsPage = lazy(() => import('src/pages/reports/TicketsPage'));
const DispatchersPage = lazy(() => import('src/pages/reports/DispatchersPage'));
const CustomersPage = lazy(() => import('src/pages/reports/CustomersPage'));
const DeliveryPage = lazy(() => import('src/pages/reports/DeliveryPage'));
const PromotionsPage = lazy(() => import('src/pages/reports/PromotionsPage'));
const PeriodSalesPage = lazy(() => import('src/pages/reports/PeriodSalesPage'));
const PreparingTimePage = lazy(
  () => import('src/pages/reports/PreparingTimePage')
);
const ProductDemandPage = lazy(
  () => import('src/pages/reports/ProductDemandPage')
);

export const reportsRoutes: AppRoute[] = [
  {
    path: 'reports',
    element: <ProtectedRoute roles={roleSet.adminToSuperAdmin} />,
    handle: {
      label: 'Отчёты',
      icon: <ViewListOutlinedIcon />,
      roles: roleSet.adminToSuperAdmin,
    },
    children: [
      {
        index: true,
        loader: async () => redirect('promocodes'),
      },
      {
        path: `promocodes`,
        element: <PromoCodesPage />,
        handle: {
          label: 'Промокоды',
          roles: roleSet.adminToSuperAdmin,
        },
      },
      {
        path: `sales`,
        element: <SalesPage />,
        handle: {
          label: 'Продажи',
          roles: roleSet.adminToSuperAdmin,
        },
      },
      {
        path: `receiving-methods`,
        element: <ReceivingMethodsPage />,
        handle: {
          label: 'Способ получения',
          roles: roleSet.adminToSuperAdmin,
        },
      },
      {
        path: `period-sales`,
        element: <PeriodSalesPage />,
        handle: {
          label: 'Товары за период',
          roles: roleSet.adminToSuperAdmin,
          nonFranchiseeAccessOnly: true,
        },
        children: periodSalesTabs,
      },
      {
        path: `delivery`,
        element: <DeliveryPage />,
        handle: {
          label: 'Доставка',
          roles: roleSet.adminToSuperAdmin,
        },
      },
      {
        path: `tickets`,
        element: <TicketsPage />,
        handle: {
          label: 'Тикеты',
          roles: roleSet.adminToSuperAdmin,
        },
      },
      {
        path: `dispatchers`,
        element: <DispatchersPage />,
        handle: {
          label: 'Диспетчеры',
          roles: roleSet.adminToSuperAdmin,
          nonFranchiseeAccessOnly: true,
        },
      },
      {
        path: `customers`,
        element: <CustomersPage />,
        handle: {
          label: 'Клиенты',
          roles: roleSet.adminToSuperAdmin,
          nonFranchiseeAccessOnly: true,
        },
      },
      {
        path: `promotions`,
        element: <PromotionsPage />,
        handle: {
          label: 'Акции',
          roles: roleSet.adminToSuperAdmin,
        },
      },
      {
        path: `preparing-time`,
        element: <PreparingTimePage />,
        handle: {
          label: 'Время приготовления',
          roles: roleSet.adminToSuperAdmin,
        },
      },
      {
        path: `product-demand`,
        element: <ProductDemandPage />,
        handle: {
          label: 'Востребованность',
          roles: roleSet.adminToSuperAdmin,
        },
      },
    ],
  },
];
